import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState, useProductFilters } from "@nosto/preact"
import { setMinMaxProductsPrice } from "../helpers"
import { useEffect } from "preact/hooks";


export default function Products({primaryFirst = true, salesBoost = false, hoverImageFirst = false}) {

    const {
        response: { products, facets },
        loading
    } = useAppState();

    const masterColors = Shopify.masterColor;
    const { filters } = useProductFilters();

    return (
        <div class="ns-d-flex ns-flex-wrap ns-product-list" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product 
                    product={hit}
                    key={hit.productId || index}
                    primaryFirst={primaryFirst}
                    salesBoost={salesBoost}
                    masterColors={masterColors}
                    categoryHoverImage={hoverImageFirst}
                    filters={filters}
                    isLast={index === (products.hits.length -1)}
                />
            })}
        </div>
    )
}
